import { useLocation } from '@react-router';

const useQueryString = (): string => {
  const location = useLocation();
  return location.search;
};

export default useQueryString;
